export default __webpack_public_path__ + "static/media/stores.06d327ad.png";